/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimCheckResponseDto
 */
export interface ClaimCheckResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ClaimCheckResponseDto
     */
    result: ClaimCheckResponseDtoResultEnum;
}


/**
 * @export
 */
export const ClaimCheckResponseDtoResultEnum = {
    Passed: 'Passed',
    Failed: 'Failed',
    Partial: 'Partial'
} as const;
export type ClaimCheckResponseDtoResultEnum = typeof ClaimCheckResponseDtoResultEnum[keyof typeof ClaimCheckResponseDtoResultEnum];


/**
 * Check if a given object implements the ClaimCheckResponseDto interface.
 */
export function instanceOfClaimCheckResponseDto(value: object): value is ClaimCheckResponseDto {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}

export function ClaimCheckResponseDtoFromJSON(json: any): ClaimCheckResponseDto {
    return ClaimCheckResponseDtoFromJSONTyped(json, false);
}

export function ClaimCheckResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimCheckResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'result': json['result'],
    };
}

export function ClaimCheckResponseDtoToJSON(json: any): ClaimCheckResponseDto {
    return ClaimCheckResponseDtoToJSONTyped(json, false);
}

export function ClaimCheckResponseDtoToJSONTyped(value?: ClaimCheckResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': value['result'],
    };
}

